import { EXCLUDED_ROUTES } from '../constants';

export function isExcludedRoute(pathname: string | null): boolean {
  if (!pathname) {
    return false;
  }
  return EXCLUDED_ROUTES.some((pattern) => pattern.test(pathname));
}
